import { combineReducers } from 'redux';

import authReducer from './auth/reducers';
import categoryReducer from './category/reducers';
import kelasReducer from './class/reducers';
import tahunAjaranReducer from './tahunAjaran/reducers';
import monthReducer from './month/reducers';
import menuTagihanReducer from './menuTagihan/reducers';
import studentReducer from './student/reducers';
import tagihanSiswaReducer from './tagihanSiswa/reducers';
import tabunganReducer from './tabungan/reducers';
import AdminRecuder from './admin/reducer';
import transaksiRedecer from './transactions/reducers';
import laporanReducer from './laporan/reducers';
import dashboardReducer from './dashboard/reducers';
const reducer = combineReducers({
  auth: authReducer,
  category: categoryReducer,
  kelas: kelasReducer,
  tahunAjaran: tahunAjaranReducer,
  month: monthReducer,
  menuTagihan: menuTagihanReducer,
  student: studentReducer,
  tagihanSiswa: tagihanSiswaReducer,
  tabungan: tabunganReducer,
  menuAdmin: AdminRecuder,
  laporan: laporanReducer,
  dashboard: dashboardReducer,
  transaksi: transaksiRedecer,
});

export default reducer;
